const RESERVED_SUBDOMAINS = new Set([
  "app",
  "www",
  "mail",
  "cpanel",
  "webmail",
  "autoconfig",
  "autodiscover",
]);

export function restaurantSlugFromHostname(
  hostname = window.location.hostname,
  search = window.location.search,
) {
  const normalized = hostname.toLowerCase().replace(/\.$/, "");
  if (normalized.endsWith(".restlab.es")) {
    const slug = normalized.slice(0, -".restlab.es".length);
    return slug && !slug.includes(".") && !RESERVED_SUBDOMAINS.has(slug)
      ? slug
      : null;
  }
  if (["localhost", "127.0.0.1"].includes(normalized)) {
    return new URLSearchParams(search).get("restaurant");
  }
  return null;
}
